module.exports = __webpack_public_path__ + "img/20f8.ccd5cd1c.jpg";